import { render, staticRenderFns } from "./ArtworkComment.vue?vue&type=template&id=57875782&scoped=true&"
import script from "./ArtworkComment.vue?vue&type=script&lang=js&"
export * from "./ArtworkComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57875782",
  null
  
)

export default component.exports